import { BiHomeAlt, BiMoneyWithdraw } from 'react-icons/bi'
import { LuClipboardList } from 'react-icons/lu';
import { FiUsers, FiClipboard } from 'react-icons/fi';
import { FaPeopleGroup } from "react-icons/fa6";
import { MdSchool } from 'react-icons/md';
import { FaUsers, FaClipboardList, FaRegHandshake } from "react-icons/fa";

export const sideBarData = [
  {
    id: 0,
    icon: BiHomeAlt,
    heading: 'Dashboard',
    permisos: ['bibliotecario', 'admin'],
  },
  {
    id: 1,
    icon: LuClipboardList,
    heading: 'Préstamos',
    permisos: ['bibliotecario', 'admin'],
  },
  {
    id: 2,
    icon: FiUsers,
    heading: 'Usuarios',
    permisos: ['bibliotecario', 'admin'],
  },
  {
    id: 3,
    icon: FiClipboard,
    heading: 'Inventario',
    permisos: ['bibliotecario', 'admin','voluntario'],
  },
  {
    id: 4,
    icon: FaRegHandshake,
    heading: 'Voluntarios',
    permisos: ['bibliotecario', 'admin'],
  },
   {
    id: 5,
    icon: FaPeopleGroup,
    heading: 'Colaboradores',
    permisos: ['admin'],
  },
];

export const cardsData = [
  {
      id: 1,
      title: 'Préstamos por Rol',
      color: {
          backGround: "linear-gradient(180deg, #bb67ff 0%, #c484f3 100%)",
          boxShadow: "0px 10px 20px 0px #e0c6f5",
      },
      png: FaUsers,
  },
  {
      id: 2,
      title: "Préstamos por Carrera",
      color: {
        backGround: "linear-gradient(180deg, #FF919D 0%, #FC929D 100%)",
        boxShadow: "0px 10px 20px 0px #FDC0C7",
      },
      png: MdSchool,
    },
    {
      id: 3,
      title: "Préstamos por Fondos",
      color: {
        backGround:
          "linear-gradient(rgb(248, 212, 154) -146.42%, rgb(255 202 113) -46.42%)",
        boxShadow: "0px 10px 20px 0px #F9D59B",
      },
      png: FaClipboardList,
    },
]